import useIsMobile from 'utils/hooks/useIsMobile'
import HelpIcon from '@mui/icons-material/Help'
import {
  Button,
  ClickAwayListener,
  Fade,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from '@mui/material'
import {KTSVG} from '_metronic/helpers'
import _ from 'lodash'
import React, {useEffect, useState} from 'react'
import {useDaumPostcodePopup} from 'react-daum-postcode'
import {Controller, useForm} from 'react-hook-form'
import {useSelector} from 'react-redux'
import {ToastContainer} from 'react-toastify'
import {getCustomerTypeList, getWorkTypeList, registerCustomer} from 'utils/apiCalling/api'
import {confirmAlert} from 'utils/CustomAlert/Alert'
import {CustomWidthTooltip} from 'utils/designSytem/CustomTooltip'
import {addressType, submitDataType} from 'utils/interface/customerType'
import {reduxType} from 'utils/interface/reduxType'
import {toolTipText} from 'utils/toolTips/toolTipText'
import BatchOffcanvas from '../modules/batchOffcanvas'
import CustomerRegisterSearch from '../modules/CustomerRegisterSearch'

const submitDataInit: submitDataType = {
  officeId: '',
  officeName: '',
  customerNumber: '',
  customerName: '',
  customerTypeId: '1',
  customerTypeName: '일반',
  customerWorkTypeId: '1',
  customerWorkTypeName: '일반용',
  addressRoad: '',
  addressNumber: '',
  addressDetail: '',
  zipCode: '',
  meterNumber: '',
  meterDiameter: '',
  checkMonth: '당월',
  checkDay: '15',
  managerName: '',
  phoneNumber: '',
  memo: '',
  contractNumber: '',
  zone: '',
}

const CustomerRegister = (props: any) => {
  const isMobile = useIsMobile()
  const {
    setError,
    register,
    handleSubmit,
    setValue,
    control,
    formState: {errors},
  } = useForm({criteriaMode: 'all', mode: 'onChange'})

  const preventEnter = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') e.preventDefault()
  }

  const [tooltipOpen, setTooltipOpen] = useState(false)
  const handleTooltipClose = () => {
    setTooltipOpen(false)
  }
  const handleTooltipOpen = () => {
    setTooltipOpen(true)
  }
  const userInfo = useSelector((state: reduxType) => state.userInfo?.userInfo)
  const [workType, setWorkType] = useState<any>(null)
  const [customerType, setCustomerType] = useState<any>(null)
  const [address, setAddress] = useState<addressType>({
    addressRoad: '',
    addressNumber: '',
  })
  const [submitData, setSubmitData] = useState<submitDataType>(submitDataInit)
  const CURRENT_URL = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js'
  const open = useDaumPostcodePopup(CURRENT_URL)
  const handleComplete = (data: any) => {
    /* 지번이 없는 신규 도로명 주소는 자동지번도 비어올 수 있으므로 빈 문자열로 맞춰 보낸다 */
    setAddress({
      ...address,
      addressRoad: data.roadAddress ?? '',
      addressNumber: (data.jibunAddress === '' ? data.autoJibunAddress : data.jibunAddress) ?? '',
    })
  }
  const onClickHandler = () => {
    open({onComplete: handleComplete})
  }

  const submitHandler = async () => {
    await registerCustomer(submitData, resetHandler)
  }
  /* 등록 성공 후에도 초기화 여부를 묻는다. 취소하면 입력값이 남아
     비슷한 수용가를 이어서 등록할 수 있다 */
  const resetHandler = async () => {
    if (await confirmAlert('초기화', 'warning')) {
      window.location.reload()
    }
  }

  /**
   * 숫자만 남겨 submitData 와 react-hook-form 양쪽에 같은 값을 넣는다.
   * setValue 로 폼 값까지 맞추지 않으면 걸러진 문자가 폼에만 남아
   * 화면은 비었는데 필수검증은 통과하는 상태가 된다.
   */
  const setOnlyNumber = (key: keyof submitDataType, rawValue: string) => {
    const onlyNumber = rawValue.replace(/\D/g, '')
    setSubmitData((prevData) => ({...prevData, [key]: onlyNumber}))
    setValue(key, onlyNumber, {shouldValidate: true})
    return onlyNumber
  }
  const handlePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) =>
    setOnlyNumber('phoneNumber', e.target.value)

  /* 숫자만 입력 가능한 필드 공통 처리 (수용가 번호 등) */
  const onlyNumberChange =
    (key: keyof submitDataType) => (e: React.ChangeEvent<HTMLInputElement>) =>
      setOnlyNumber(key, e.target.value)

  /* 목록에 없는 값이 들어와도 터지지 않도록 find 결과를 확인한 뒤 반영한다 */
  const handleCustomerTypeChange = (value: any) => {
    const selected = _.find(customerType, (item: any) => item.customerTypeName === value)
    if (!selected) return
    setSubmitData((prevData) => ({
      ...prevData,
      customerTypeId: selected.idx,
      customerTypeName: selected.customerTypeName,
    }))
  }
  const handleWorkTypeChange = (value: any) => {
    const selected = _.find(workType, (item: any) => item.customerWorkTypeName === value)
    if (!selected) return
    setSubmitData((prevData) => ({
      ...prevData,
      customerWorkTypeId: selected.idx,
      customerWorkTypeName: selected.customerWorkTypeName,
    }))
  }

  useEffect(() => {
    getWorkTypeList(userInfo, setWorkType)
    getCustomerTypeList(userInfo, setCustomerType)
  }, [])
  useEffect(() => {
    setSubmitData((prevData) => ({
      ...prevData,
      addressRoad: address.addressRoad,
      addressNumber: address.addressNumber,
    }))
    setValue('addressRoad', address.addressRoad, {shouldValidate: address.addressRoad !== ''})
    setValue('addressNumber', address.addressNumber)
  }, [address.addressRoad, address.addressNumber])

  return (
    <>
      {!isMobile && (
        <div className='card flex-grow-1' id='customer-register' style={{fontSize: '16px'}}>
          <div className='card-header cursor-pointer'>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>{toolTipText.customerRegister.description}</h3>
              <CustomWidthTooltip
                title={toolTipText.customerRegister.text}
                TransitionComponent={Fade}
                TransitionProps={{timeout: 600}}
                placement={'right-start'}
                arrow={true}
                sx={{fontSize: '10px', letterSpacing: '1px', cursor: 'pointer'}}
              >
                <HelpIcon
                  color={'primary'}
                  sx={{fontSize: '24px'}}
                  className={'ms-4 mb-2 cursor-pointer'}
                />
              </CustomWidthTooltip>
            </div>

            <button
              className={'btn btn-primary align-self-center'}
              data-bs-toggle={'offcanvas'}
              data-bs-target='#batchRegister'
              aria-controls='batchRegister'
            >
              일괄등록
            </button>
          </div>
          <BatchOffcanvas />
          <div className='card-body p-9'>
            <form onSubmit={handleSubmit(submitHandler)}>
              <div className={'row row-cols gap-10 mb-5'}>
                <div className={'col-lg'}>
                  <div className={'row my-4'}>
                    <div className={'pe-0 row'}>
                      <div className={'pe-0 col-9'}>
                        <label className='mb-3 fw-bold text-muted'>
                          사업소
                          <span className={'fw-bolder fs-3 ms-1'} style={{color: 'red'}}>
                            *
                          </span>
                        </label>
                        <div className={'d-flex gap-3'}>
                          <CustomerRegisterSearch
                            register={register}
                            name='officeName'
                            setValue={setValue}
                            setSubmitData={setSubmitData}
                            submitData={submitData}
                            errors={errors}
                          />
                        </div>
                      </div>
                      <div className={'pe-0 col-3'}>
                        <label className='mb-3 fw-bold text-muted'>
                          계약 번호
                          <span className={'fw-bolder fs-3 ms-1'} style={{color: 'white'}}></span>
                        </label>
                        <div className={'d-flex gap-3 '}>
                          <TextField
                            {...register('contractNumber', {
                              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                                setSubmitData({...submitData, contractNumber: e.target.value})
                              },
                            })}
                            label='계약번호'
                            variant='outlined'
                            value={submitData?.contractNumber}
                            fullWidth
                            onKeyDown={preventEnter}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={'row my-4'}>
                    <label className='mb-3 fw-bold text-muted'>
                      수용가
                      <span className={'fw-bolder fs-3 ms-1'} style={{color: 'red'}}>
                        *
                      </span>
                    </label>
                    <div className={'d-flex gap-3'}>
                      <TextField
                        {...register('customerNumber', {
                          onChange: onlyNumberChange('customerNumber'),
                          required: {
                            value: true,
                            message: '필수 입력 사항입니다.',
                          },
                        })}
                        label='수용가 번호'
                        variant='outlined'
                        inputProps={{inputMode: 'numeric'}}
                        value={submitData?.customerNumber}
                        fullWidth
                        onKeyDown={preventEnter}
                        error={errors.customerNumber ? true : false}
                        helperText={
                          errors.customerNumber ? (
                            <span className={'fs-6 fw-bold text-danger'}>
                              {String(errors.customerNumber.message)}
                            </span>
                          ) : (
                            ''
                          )
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id='demo-simple-select-label'>수용가 종류</InputLabel>
                        <Controller
                          name='customerTypeName'
                          control={control}
                          defaultValue={submitData?.customerTypeName}
                          render={({field}) => (
                            <Select
                              {...field}
                              labelId='demo-simple-select-label'
                              label='수용가 종류'
                              onChange={(e: any) => {
                                field.onChange(e)
                                handleCustomerTypeChange(e.target.value)
                              }}
                            >
                              {_.map(customerType, (el, i) => {
                                return (
                                  <MenuItem value={el.customerTypeName} key={i}>
                                    {el.customerTypeName}
                                  </MenuItem>
                                )
                              })}
                            </Select>
                          )}
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel id='demo-simple-select-label'>수용가 업종</InputLabel>

                        <Controller
                          name='customerWorkTypeName'
                          control={control}
                          defaultValue={submitData?.customerWorkTypeName}
                          render={({field}) => (
                            <Select
                              {...field}
                              labelId='demo-simple-select-label'
                              label='수용가 업종'
                              onChange={(e: any) => {
                                field.onChange(e)
                                handleWorkTypeChange(e.target.value)
                              }}
                            >
                              {_.map(workType, (el, i) => {
                                return (
                                  <MenuItem value={el.customerWorkTypeName} key={i}>
                                    {el.customerWorkTypeName}
                                  </MenuItem>
                                )
                              })}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </div>
                  </div>

                  <div className={'row my-4'}>
                    <div className={'row row-cols-2 pe-0'}>
                      <div className={'pe-0'}>
                        <label className='mb-3 fw-bold text-muted'>
                          이름
                          <span className={'fw-bolder fs-3 ms-1'} style={{color: 'red'}}>
                            *
                          </span>
                        </label>
                        <div className={'d-flex gap-3'}>
                          <TextField
                            {...register('customerName', {
                              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                                setSubmitData({...submitData, customerName: e.target.value})
                              },
                              required: {
                                value: true,
                                message: '필수 입력 사항입니다.',
                              },
                            })}
                            label='이름'
                            variant='outlined'
                            value={submitData?.customerName}
                            fullWidth
                            onKeyDown={preventEnter}
                            error={errors.customerName ? true : false}
                            helperText={
                              errors.customerName ? (
                                <span className={'fs-6 fw-bold text-danger'}>
                                  {String(errors.customerName.message)}
                                </span>
                              ) : (
                                ''
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className={'pe-0'}>
                        <label className='mb-3 fw-bold text-muted d-flex'>전화번호</label>
                        <div className={'d-flex gap-3'}>
                          <TextField
                            {...register('phoneNumber', {
                              onChange: handlePhoneNumber,
                            })}
                            label='전화번호'
                            variant='outlined'
                            inputProps={{inputMode: 'numeric'}}
                            placeholder={'- 없이 숫자만 입력해주세요.'}
                            value={submitData?.phoneNumber}
                            fullWidth
                            onKeyDown={preventEnter}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={'row my-4 gap-3'}>
                    <label className='mb-3 fw-bold text-muted'>
                      주소
                      <span className={'fw-bolder fs-3 ms-1'} style={{color: 'red'}}>
                        *
                      </span>
                    </label>
                    <div className={'d-flex gap-3 col'}>
                      <TextField
                        {...register('addressRoad', {
                          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                            setValue('addressRoad', e.target.value)
                            setSubmitData({...submitData, addressRoad: e.target.value})
                          },
                          required: {
                            value: true,
                            message: '필수 입력 사항입니다.',
                          },
                        })}
                        label='도로명 주소'
                        variant='filled'
                        value={
                          submitData.addressRoad !== ''
                            ? submitData.addressRoad
                            : address?.addressRoad
                        }
                        onKeyDown={preventEnter}
                        error={errors.addressRoad ? true : false}
                        className={'col'}
                        helperText={
                          errors.addressRoad ? (
                            <span className={'fs-6 fw-bold text-danger'}>
                              {String(errors.addressRoad.message)}
                            </span>
                          ) : (
                            ''
                          )
                        }
                      />
                      <TextField
                        {...register('addressNumber', {
                          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                            setSubmitData({...submitData, addressNumber: e.target.value})
                          },
                        })}
                        label='지번주소'
                        variant='filled'
                        value={
                          submitData.addressNumber !== ''
                            ? submitData.addressNumber
                            : address?.addressNumber
                        }
                        onKeyDown={preventEnter}
                        className={'col'}
                      />
                      <Button
                        variant={'contained'}
                        size={'large'}
                        color={'primary'}
                        type='button'
                        onClick={onClickHandler}
                        className={'col-1 fs-6'}
                      >
                        {address.addressRoad !== '' ? '재검색' : '찾기'}
                      </Button>
                    </div>

                    <div className={'gap-3 d-flex'}>
                      <div className={'col-9'}>
                        <TextField
                          {...register('addressDetail', {
                            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                              setSubmitData({...submitData, addressDetail: e.target.value})
                            },
                          })}
                          label='상세주소'
                          defaultValue={submitData?.addressDetail}
                          variant='outlined'
                          fullWidth
                        />
                      </div>
                      <div>
                        <TextField
                          {...register('zone', {
                            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                              setSubmitData({...submitData, zone: e.target.value})
                            },
                          })}
                          label='분구'
                          variant='outlined'
                          defaultValue={submitData?.zone}
                          onKeyDown={preventEnter}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'col-lg'}>
                  <div className={'row my-4'}>
                    <div className={'row row-cols-2'}>
                      <div>
                        <label className='mb-3 fw-bold text-muted'>계량기 번호</label>
                        <div className={'d-flex gap-3'}>
                          <TextField
                            {...register('meterNumber', {
                              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                                setSubmitData({...submitData, meterNumber: e.target.value})
                              },
                            })}
                            label='계량기 번호'
                            variant='outlined'
                            defaultValue={submitData?.meterNumber}
                            fullWidth
                            placeholder={'계량기 번호를 입력해주세요.'}
                          />
                        </div>
                      </div>
                      <div>
                        <label className='mb-3 fw-bold text-muted d-flex'>구경</label>
                        <div className={'d-flex gap-3'}>
                          <TextField
                            {...register('meterDiameter', {
                              onChange: onlyNumberChange('meterDiameter'),
                            })}
                            label='구경'
                            variant='outlined'
                            inputProps={{inputMode: 'numeric'}}
                            value={submitData?.meterDiameter}
                            placeholder={'구경의 단위는 mm 입니다.'}
                            fullWidth
                            onKeyDown={preventEnter}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={'row my-4'}>
                    <label className='mb-3 fw-bold text-muted'>검침일</label>
                    <div className={'d-flex gap-3'}>
                      <FormControl className={'col-lg-3'}>
                        <InputLabel id='demo-simple-select-label'>납부 고지 월</InputLabel>
                        <Controller
                          name='checkMonth'
                          control={control}
                          defaultValue={submitData?.checkMonth}
                          render={({field}) => (
                            <Select
                              {...field}
                              labelId='demo-simple-select-label'
                              label='납부 고지 월'
                              defaultValue={submitData?.checkMonth}
                              onChange={(e) => {
                                field.onChange(e)
                                setSubmitData({...submitData, checkMonth: e.target.value})
                              }}
                            >
                              <MenuItem value={'당월'}>당월</MenuItem>
                              <MenuItem value={'전월'}>전월</MenuItem>
                            </Select>
                          )}
                        />
                      </FormControl>
                      <TextField
                        {...register('checkDay', {
                          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                            setSubmitData({...submitData, checkDay: e.target.value})
                          },

                          validate: (value) => {
                            const day = parseInt(value)
                            if (isNaN(day) || day < 1 || day > 31) {
                              return '1부터 31까지의 숫자를 입력해주세요.'
                            }
                            return true
                          },
                        })}
                        label='검침일'
                        variant='outlined'
                        type={'number'}
                        placeholder={'ex) 3'}
                        className={'col-3'}
                        defaultValue={submitData?.checkDay}
                        onKeyDown={preventEnter}
                        error={errors.checkDay ? true : false}
                        helperText={
                          errors.checkDay ? (
                            <span className={'fs-6 fw-bold text-danger'}>
                              {String(errors.checkDay.message)}
                            </span>
                          ) : (
                            <span className={'fs-7 fw-semibold'}>숫자만 입력가능합니다.</span>
                          )
                        }
                      />
                      <span className={'fw-bold mt-5'}>일</span>
                    </div>
                  </div>

                  <div className={'row my-4'}>
                    <label className='mb-3 fw-bold text-muted'>담당자</label>
                    <div className={'d-flex gap-3'}>
                      <TextField
                        {...register('managerName', {
                          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                            setSubmitData({...submitData, managerName: e.target.value})
                          },
                        })}
                        label='담당자'
                        variant='outlined'
                        placeholder={'담당자를 입력해주세요'}
                        value={submitData?.managerName}
                        error={errors.managerName ? true : false}
                        helperText={
                          errors.managerName ? (
                            <span className={'fs-6 fw-bold text-danger'}>
                              {String(errors.managerName.message)}
                            </span>
                          ) : (
                            ''
                          )
                        }
                      />
                    </div>
                  </div>

                  <div className={'row my-4'}>
                    <label className='mb-3 fw-bold text-muted'>메모</label>
                    <div className={'d-flex gap-3'}>
                      <TextField
                        {...register('memo', {
                          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                            setSubmitData({...submitData, memo: e.target.value})
                          },
                        })}
                        label='메모'
                        variant='outlined'
                        placeholder={'메모를 입력해주세요.'}
                        fullWidth
                        multiline
                        defaultValue={submitData?.memo}
                        rows={2}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={'card-footer'}>
                <div className={'d-flex justify-content-end gap-5'}>
                  <div
                    className={'btn btn-danger align-self-center'}
                    onKeyDown={preventEnter}
                    onClick={() => {
                      resetHandler()
                    }}
                  >
                    초기화
                  </div>
                  <button className={'btn btn-primary align-self-center'} type='submit'>
                    등록
                  </button>
                </div>
              </div>
            </form>

            <div className='notice d-flex  bg-light-warning rounded border-warning border border-dashed p-6 bottom-0 position-absolute w-75 mb-5 '>
              <KTSVG
                path='icons/duotune/general/gen044.svg'
                className='svg-icon-2tx svg-icon-warning me-4'
              />
              <div className='d-flex flex-stack flex-grow-1'>
                <div className='fw-bold'>
                  <h4 className='text-gray-800 fw-bolder'>필수정보를 입력해주세요</h4>
                  <div className='fs-6 text-gray-600'>
                    문의사항은 영아이티 개발팀으로 연락바랍니다.
                    <a
                      className='fw-bolder'
                      href='https://young-it.co.kr'
                      target={'_blank'}
                      rel='noreferrer'
                    >
                      YOUNG-IT
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isMobile && (
        <div className='card flex-grow-1' id='customer-register'>
          <div className='card-header cursor-pointer'>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>{toolTipText.customerRegister.description}</h3>
              <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip
                  title={toolTipText.customerRegister.text}
                  className={'align-self-center'}
                  onClose={handleTooltipClose}
                  open={tooltipOpen}
                  TransitionComponent={Fade}
                  TransitionProps={{timeout: 600}}
                  placement={'bottom'}
                  PopperProps={{
                    disablePortal: true,
                  }}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  arrow={true}
                >
                  <HelpIcon
                    onClick={handleTooltipOpen}
                    color={'primary'}
                    sx={{fontSize: '24px'}}
                    className={'ms-4'}
                  />
                </Tooltip>
              </ClickAwayListener>
            </div>
            <button
              className={'btn btn-primary align-self-center'}
              data-bs-toggle={'offcanvas'}
              data-bs-target='#batchRegister'
              aria-controls='batchRegister'
            >
              일괄등록
            </button>
          </div>
          <BatchOffcanvas />
          <div className='card-body p-9'>
            <form onSubmit={handleSubmit(submitHandler)}>
              <div className='container-fluid'>
                <div className='row gap-4 my-3'>
                  <span className={' fs-3 my-0 text-muted fw-bolder'}>
                    수용가 정보<strong className={'text-danger fw-bolder fs-5 mx-1'}>*</strong>
                  </span>
                  <div className={'d-flex gap-3 px-0'}>
                    <CustomerRegisterSearch
                      register={register}
                      name='officeName'
                      setValue={setValue}
                      setSubmitData={setSubmitData}
                      submitData={submitData}
                      errors={errors}
                    />
                  </div>
                  <div className={'d-flex gap-3 px-0'}>
                    <FormControl fullWidth>
                      <InputLabel id='demo-simple-select-label'>수용가 종류</InputLabel>
                      <Controller
                        name='customerTypeName'
                        control={control}
                        defaultValue={submitData?.customerTypeName}
                        render={({field}) => (
                          <Select
                            {...field}
                            labelId='demo-simple-select-label'
                            label='수용가 종류'
                            onChange={(e: any) => {
                              field.onChange(e)
                              handleCustomerTypeChange(e.target.value)
                            }}
                          >
                            {_.map(customerType, (el, i) => {
                              return (
                                <MenuItem value={el.customerTypeName} key={i}>
                                  {el.customerTypeName}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        )}
                      />
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel id='demo-simple-select-label'>수용가 업종</InputLabel>

                      <Controller
                        name='customerWorkTypeName'
                        control={control}
                        defaultValue={submitData?.customerWorkTypeName}
                        render={({field}) => (
                          <Select
                            {...field}
                            labelId='demo-simple-select-label'
                            label='수용가 업종'
                            onChange={(e: any) => {
                              field.onChange(e)
                              handleWorkTypeChange(e.target.value)
                            }}
                          >
                            {_.map(workType, (el, i) => {
                              return (
                                <MenuItem value={el.customerWorkTypeName} key={i}>
                                  {el.customerWorkTypeName}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className={'d-flex gap-3 px-0'}>
                    <TextField
                      {...register('customerNumber', {
                        onChange: onlyNumberChange('customerNumber'),
                        required: {
                          value: true,
                          message: '필수 입력 사항입니다.',
                        },
                      })}
                      label='수용가 번호 *'
                      variant='outlined'
                      inputProps={{inputMode: 'numeric'}}
                      value={submitData?.customerNumber}
                      fullWidth
                      onKeyDown={preventEnter}
                      error={errors.customerNumber ? true : false}
                      helperText={
                        errors.customerNumber ? (
                          <span className={'fs-6 fw-bold text-danger'}>
                            {String(errors.customerNumber.message)}
                          </span>
                        ) : (
                          ''
                        )
                      }
                    />
                    <TextField
                      {...register('contractNumber', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, contractNumber: e.target.value})
                        },
                      })}
                      label='계약번호'
                      variant='outlined'
                      value={submitData?.contractNumber}
                      fullWidth
                      onKeyDown={preventEnter}
                    />
                  </div>
                </div>

                <div className='row gap-4 my-3'>
                  <span className={'fs-3 text-muted fw-bolder'}>
                    수용가 이름 및 전화번호
                    <strong className={'text-danger fw-bolder fs-5 mx-1'}>*</strong>
                  </span>
                  <div className={'d-flex gap-3 px-0'}>
                    <TextField
                      {...register('customerName', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, customerName: e.target.value})
                        },
                        required: {
                          value: true,
                          message: '필수 입력 사항입니다.',
                        },
                      })}
                      label='이름 *'
                      variant='outlined'
                      value={submitData?.customerName}
                      fullWidth
                      onKeyDown={preventEnter}
                      error={errors.customerName ? true : false}
                      helperText={
                        errors.customerName ? (
                          <span className={'fs-6 fw-bold text-danger'}>
                            {String(errors.customerName.message)}
                          </span>
                        ) : (
                          ''
                        )
                      }
                    />
                    <TextField
                      {...register('phoneNumber', {
                        onChange: handlePhoneNumber,
                      })}
                      label='전화번호'
                      variant='outlined'
                      inputProps={{inputMode: 'numeric'}}
                      placeholder={'- 없이 숫자만 입력해주세요.'}
                      value={submitData?.phoneNumber}
                      fullWidth
                      onKeyDown={preventEnter}
                    />
                  </div>
                </div>

                <div className='row gap-4 my-3'>
                  <span className={'fs-3 text-muted fw-bolder'}>
                    주소
                    <strong className={'text-danger fw-bolder fs-5 mx-1'}>*</strong>
                  </span>

                  <TextField
                    {...register('addressRoad', {
                      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                        setValue('addressRoad', e.target.value)
                        setSubmitData({...submitData, addressRoad: e.target.value})
                      },
                      required: {
                        value: true,
                        message: '필수 입력 사항입니다.',
                      },
                    })}
                    label='도로명 주소 *'
                    variant='filled'
                    value={
                      submitData.addressRoad !== '' ? submitData.addressRoad : address?.addressRoad
                    }
                    onKeyDown={preventEnter}
                    fullWidth
                    error={errors.addressRoad ? true : false}
                  />
                  <TextField
                    {...register('addressNumber', {
                      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                        setSubmitData({...submitData, addressNumber: e.target.value})
                      },
                    })}
                    label='지번주소'
                    variant='filled'
                    value={
                      submitData.addressNumber !== ''
                        ? submitData.addressNumber
                        : address?.addressNumber
                    }
                    onKeyDown={preventEnter}
                    fullWidth
                  />
                  <div className={'d-flex gap-3 px-0'}>
                    <TextField
                      {...register('addressDetail', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, addressDetail: e.target.value})
                        },
                      })}
                      label='상세주소'
                      defaultValue={submitData?.addressDetail}
                      variant='outlined'
                      className={'col-9'}
                    />
                    <TextField
                      {...register('zone', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, zone: e.target.value})
                        },
                      })}
                      label='분구'
                      variant='outlined'
                      defaultValue={submitData?.zone}
                      onKeyDown={preventEnter}
                    />
                  </div>
                  <Button
                    variant={'contained'}
                    size={'large'}
                    color={'primary'}
                    type='button'
                    onClick={onClickHandler}
                  >
                    {submitData.addressRoad !== '' ? '다시 검색' : '찾기'}
                  </Button>
                  {errors?.addressRoad ? (
                    <FormHelperText className={'fs-6 fw-bold text-danger'}>
                      {String(errors.addressRoad.message)}
                    </FormHelperText>
                  ) : (
                    ''
                  )}
                </div>

                <div className='row gap-4 my-5'>
                  <span className={'fs-3 text-muted fw-bolder'}>계량기 정보</span>
                  <div className={'d-flex gap-3 px-0'}>
                    <TextField
                      {...register('meterNumber', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, meterNumber: e.target.value})
                        },
                      })}
                      label='계량기 번호'
                      variant='outlined'
                      defaultValue={submitData?.meterNumber}
                      fullWidth
                      placeholder={'계량기 번호를 입력해주세요.'}
                    />
                    <TextField
                      {...register('meterDiameter', {
                        onChange: onlyNumberChange('meterDiameter'),
                      })}
                      label='구경'
                      variant='outlined'
                      inputProps={{inputMode: 'numeric'}}
                      value={submitData?.meterDiameter}
                      placeholder={'구경의 단위는 mm 입니다.'}
                      fullWidth
                      onKeyDown={preventEnter}
                    />
                  </div>
                </div>

                <div className='row gap-4 my-3'>
                  <span className={'fs-3 text-muted fw-bolder'}>검침일 정보</span>
                  <div className={'d-flex gap-3 px-0'}>
                    <FormControl fullWidth>
                      <InputLabel id='demo-simple-select-label'>납부 고지 월</InputLabel>
                      <Controller
                        name='checkMonth'
                        control={control}
                        defaultValue={submitData?.checkMonth}
                        render={({field}) => (
                          <Select
                            {...field}
                            labelId='demo-simple-select-label'
                            label='납부 고지 월'
                            defaultValue={submitData?.checkMonth}
                            onChange={(e) => {
                              field.onChange(e)
                              setSubmitData({...submitData, checkMonth: e.target.value})
                            }}
                          >
                            <MenuItem value={'당월'}>당월</MenuItem>
                            <MenuItem value={'전월'}>전월</MenuItem>
                          </Select>
                        )}
                      />
                    </FormControl>
                    <TextField
                      {...register('checkDay', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, checkDay: e.target.value})
                        },

                        validate: (value) => {
                          const day = parseInt(value)
                          if (isNaN(day) || day < 1 || day > 31) {
                            return '1부터 31까지의 숫자를 입력해주세요.'
                          }
                          return true
                        },
                      })}
                      label='검침일'
                      variant='outlined'
                      type={'number'}
                      placeholder={'ex) 3'}
                      className={'col-5'}
                      defaultValue={submitData?.checkDay}
                      onKeyDown={preventEnter}
                      error={errors.checkDay ? true : false}
                      helperText={
                        errors.checkDay ? (
                          <span className={'fs-6 fw-bold text-danger'}>
                            {String(errors.checkDay.message)}
                          </span>
                        ) : (
                          <></>
                        )
                      }
                    />
                    <span className={'fw-bold mt-7'} style={{fontSize: '22px'}}>
                      일
                    </span>
                  </div>
                </div>
                <div className='row gap-4 my-3'>
                  <span className={'fs-3 text-muted fw-bolder'}>담당자</span>
                  <div className={'d-flex gap-3 px-0 mx-0'}>
                    <TextField
                      {...register('managerName', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, managerName: e.target.value})
                        },
                      })}
                      label='담당자'
                      variant='outlined'
                      placeholder={'담당자를 입력해주세요'}
                      value={submitData?.managerName}
                      error={errors.managerName ? true : false}
                      helperText={
                        errors.managerName ? (
                          <span className={'fs-6 fw-bold text-danger'}>
                            {String(errors.managerName.message)}
                          </span>
                        ) : (
                          ''
                        )
                      }
                    />
                  </div>
                </div>
                <div className={'row gap-4 my-3'}>
                  <span className={'fs-3 text-muted fw-bolder'}>메모</span>
                  <div className={'d-flex gap-3 px-0'}>
                    <TextField
                      {...register('memo', {
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setSubmitData({...submitData, memo: e.target.value})
                        },
                      })}
                      label='메모'
                      variant='outlined'
                      placeholder={'메모를 입력해주세요.'}
                      fullWidth
                      multiline
                      defaultValue={submitData?.memo}
                      rows={2}
                    />
                  </div>
                </div>
              </div>

              <div className={'card-footer p-4'}>
                <div className={'d-flex justify-content-end gap-5'}>
                  <Button
                    className={' align-self-center'}
                    variant={'contained'}
                    color={'error'}
                    size={'large'}
                    type={'button'}
                    onClick={resetHandler}
                  >
                    초기화
                  </Button>
                  <Button
                    className={' align-self-center'}
                    variant={'contained'}
                    color={'info'}
                    size={'large'}
                    type={'submit'}
                  >
                    등록
                  </Button>
                </div>
              </div>
            </form>
            <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
              <KTSVG
                path='icons/duotune/general/gen044.svg'
                className='svg-icon-2tx svg-icon-warning me-4'
              />
              <div className='d-flex flex-stack flex-grow-1'>
                <div className='fw-bold'>
                  <h4 className='text-gray-800 fw-bolder'>필수정보를 입력해주세요</h4>
                  <div className='fs-6 text-gray-600'>
                    문의사항은 영아이티 개발팀으로 연락바랍니다.
                    <a
                      className='fw-bolder'
                      href='https://young-it.co.kr'
                      target='_blank'
                      rel='noreferrer'
                    >
                      {' '}
                      YOUNG-IT
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  )
}

export default CustomerRegister
